import type { ReactNode } from 'react';
import { CatalogSection } from './catalog/Catalog';

/**
 * **What they sell** — a list with one editor beside it (phase B4,
 * `./catalog/`).
 *
 * `seedFrom` is the owner's menu handed over from the Website tab's intake
 * card ("Seed this"). The page holds it above the tabs and switches here when
 * it is handed, so the file lands in the box it fills; nothing is written until
 * an operator presses Dry run and then Seed this.
 *
 * `item` is the open item from the address (`?item=`), and `onItem` moves it.
 */
export function CatalogTab({
  tenantId,
  seedFrom,
  currency,
  item,
  onItem,
}: {
  tenantId: string;
  seedFrom: string | null;
  currency?: string | undefined;
  item?: string | undefined;
  onItem?: ((item: string | undefined) => void) | undefined;
}): ReactNode {
  return (
    <CatalogSection
      tenantId={tenantId}
      seedFrom={seedFrom}
      currency={currency}
      item={item}
      onItem={onItem}
    />
  );
}
